import type { BlockType } from '~/types/AppData/Blocks/BlockType';
import { addVideoPlayerToBody } from './experiments/videoPlacement';

export const maybeMoveVideoPlayer = (
  body: BlockType[],
  edition: string,
  isMobileViewer: boolean
): BlockType[] | [] => {
  // Move the video player for fansided.com
  if (edition !== '229') return body;

  // TODO: Remove once the desktop video placement experiment ends.
  if (isMobileViewer) {
    return addVideoPlayerToBody(body, 'mobile');
  }

  return body;
};
